import React, { memo, forwardRef } from "react";
const SvgLesserthanorequalto = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.552 6.106a1 1 0 01.894 1.789L11.236 14l12.21 6.106a1 1 0 01-.894 1.789l-14-7a1 1 0 010-1.79l14-7zM22.999 23a1 1 0 110 2h-14a1 1 0 110-2h14z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgLesserthanorequalto.displayName = "SvgLesserthanorequalto";
const MemoForwardRef = memo(SvgLesserthanorequalto);
export default MemoForwardRef;
